export default __webpack_public_path__ + "static/InfoQ_DevSummit_Boston_2025-469bd406c3eab4f5d5573b1c12b7f769.png";